// Grouped pairing constants + helpers; intentionally multiple exports.
/* eslint-disable eag/match-named-export */
import {includes, isNotNil} from 'ramda';

import i18n from '@dms/i18n';

export const RECORD_AUDIT_PAIR_RESOURCE_IDS = [
  'BUSINESS_CASE',
  'SERVICE_CASE',
  'SERVICE_ORDER',
  'RENTAL_ORDER',
  'VEHICLE',
  'INTEREST',
  'WORKSHOP_INTEREST',
] as const;

export type RecordAuditPairResourceId = (typeof RECORD_AUDIT_PAIR_RESOURCE_IDS)[number];

// Linked picker datagrids registered BE-side under T20-123365. Each one wraps
// the resource's main DG and flips RowSelectMode to SINGLE so the dialog can
// select a row. Column trimming is intentionally minimal for the POC — see the
// matching BE provider TODO banners for the picker-relevant column subset.
export const RECORD_AUDIT_PAIR_GRID_CODES: Record<RecordAuditPairResourceId, string> = {
  BUSINESS_CASE: 'record-audit-pair-business-case',
  SERVICE_CASE: 'record-audit-pair-service-case',
  SERVICE_ORDER: 'record-audit-pair-service-order',
  RENTAL_ORDER: 'record-audit-pair-rental-order',
  VEHICLE: 'record-audit-pair-vehicle',
  INTEREST: 'record-audit-pair-interest',
  WORKSHOP_INTEREST: 'record-audit-pair-workshop-interest',
};

export const getRecordAuditPairResourceLabel = (resourceId: RecordAuditPairResourceId): string =>
  i18n.t(`page.checklistAudits.pairing.resources.${resourceId}`);

export const isRecordAuditPairResourceId = (
  value: string | null | undefined
): value is RecordAuditPairResourceId =>
  isNotNil(value) && includes(value, RECORD_AUDIT_PAIR_RESOURCE_IDS);
